import { useTranslation } from 'react-i18next';

import useAppModal from 'hooks/useAppModal';
import { ScheduledMessage } from 'models/automation/ScheduledMessages';
import ScheduledMessagesSendNowModal from './ScheduledMessagesSendNowModal';

const modalId = 'scheduled-messages-send-now-modal';

const useScheduledMessagesSendNowModal = () => {
  const { openModal } = useAppModal();
  const { t } = useTranslation();

  const openSendNowScheduledMessagesModal = ({
    scheduledMessage,
  }: {
    scheduledMessage: ScheduledMessage;
  }) => {
    openModal({
      customContent: (
        <ScheduledMessagesSendNowModal scheduledMessage={scheduledMessage} />
      ),
      id: modalId,
      title: t('pageAutomations.scheduledMessages.modalSendNow.title'),
    });
  };

  return { openSendNowScheduledMessagesModal };
};

export default useScheduledMessagesSendNowModal;
